import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SuccessFilled"
});
const _hoisted_1 = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-596.000000, -414.000000)" fill="currentColor"><g transform="translate(580.000000, 398.000000)"><g transform="translate(16.000000, 16.000000)"><path d="M7.99998531,1.5 C4.4101592,1.5 1.5,4.4101592 1.5,8 C1.5,11.5898551 4.41014451,14.5 7.99998531,14.5 C11.5898707,14.5 14.5,11.5898551 14.5,8 C14.5,4.4101592 11.5898551,1.5 7.99998531,1.5 Z M11.8024684,6.12839648 L7.07779098,10.7923655 L4.14559935,7.93424407 L5.07409651,6.94630066 L7.07859288,8.95079701 L10.8665777,5.1627975 L11.8024684,6.12839648 Z"></path></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var successFilled = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { successFilled as default };
